import {
  Currency,
  type CurrencyConstructor,
} from '@webapp/core/entities/external/Currency'

export interface LegalEntitySummaryWithBaseCurrencyConstructor {
  id: number
  uuid: string
  name: string
  baseCurrency: CurrencyConstructor
}

export class LegalEntitySummaryWithBaseCurrency {
  readonly id: number
  readonly uuid: string
  readonly name: string
  readonly baseCurrency: Currency

  constructor(data: LegalEntitySummaryWithBaseCurrencyConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.name = data.name
    this.baseCurrency = new Currency(data.baseCurrency)
  }
}
